import React from 'react';
import { useTranslation } from 'react-i18next';

import 'bootstrap/dist/css/bootstrap.min.css';
import GenerateNotificationFeed from '../notifications/GenerateNotificationFeed';
import IntegratedSearchNavBar from '../navigation/IntegratedSearchNavBar';

const NotificationPage = () => {
  const { t } = useTranslation('common');

  // /notifications is listed in AppLayout's pagesWithOwnSearchBar, so the bar
  // has to be mounted here -- AppLayout will not add one.
  //
  // Passing pageTitle puts the bar in title mode, which is what suppresses the
  // Federal / State / Local switcher: the path has no country segment, so the
  // bar would otherwise fall back to the stored country and render a switcher
  // that has nothing to switch on this page. The notification-specific controls
  // (settings gear, search, topic picker) live in the page body instead, since
  // the bar's inline slot is fed by FeedFilterBar and these aren't feed filters.
  //
  // reserveNavSpace (default true) renders the measured spacer, so the page no
  // longer needs the hardcoded <br /> stack that used to clear the fixed bar.
  const homeCountry = localStorage.getItem('homeCountry') || 'us';

  return (
    <>
      <IntegratedSearchNavBar
        currentCountry={homeCountry}
        pageTitle={t('common:notifications', 'Notifications')}
      />

      <div id="homebg">
        <GenerateNotificationFeed />

        {/* Clearance for the fixed BottomNavbar. */}
        <br /><br /><br /><br /><br /><br />
      </div>
    </>
  );
};

export default NotificationPage;